export default __webpack_public_path__ + "static/media/user_details.0625c876.webp";